import { render, staticRenderFns } from "./ImportSkillModal.vue?vue&type=template&id=059c78a6&scoped=true"
import script from "./ImportSkillModal.vue?vue&type=script&lang=js"
export * from "./ImportSkillModal.vue?vue&type=script&lang=js"
import style0 from "./ImportSkillModal.vue?vue&type=style&index=0&id=059c78a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c78a6",
  null
  
)

export default component.exports